import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { SignalTileState } from 'widgets/signalTiles/signalTile/state/SignalTileState';
import { buildSignalTileConfigSlice } from 'widgets/signalTiles/signalTile/state/config/configslice';
import State from 'store/State';
import { SignalTileConfigState } from 'widgets/signalTiles/signalTile/state/config/SignalTileConfigState';
import { SignalTileActionPayload } from 'widgets/signalTiles/signalTile/state/actions';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';

export function buildSignalTileReducer(
    widgetType: WidgetType,
    selectWidgetState: (state: State, widgetKey: string) => SignalTileState,
    initialConfigState: SignalTileConfigState
) {
    const { reducer: configReducer } = buildSignalTileConfigSlice(
        widgetType,
        selectWidgetState,
        initialConfigState
    );

    const tileStateReducer = combineReducers<SignalTileState>({
        config: configReducer,
    });

    return createWidgetsReducer<SignalTileState, SignalTileActionPayload>(
        widgetType,
        tileStateReducer
    );
}
